import * as React from 'react'
import { SvgIconProps } from './VesselIcon'

const DashedLine: React.FC<SvgIconProps> = ({ color }) => (
    <svg
        height={26}
        width={24}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 26"
    >
        <g fill="none" stroke={color} strokeWidth={2}>
            <path strokeDasharray="2,2" d="M1 13 l22 0" />
        </g>
    </svg>
)
export default DashedLine
